import React from 'react'
import Judul from 'components/dashboard/dashcomp/judul'
import {Row, Col} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import './style.css'

export default function Buku(props) {
    return (
        <div className="category-buku">
            <Judul judul="Kitab Islami" />
            <Row>
                {
                    Images.map((img, i) => {
                        return (
                            <Col key={i} md={2}>
                               <Link to={props.to}>
                                    <div className="cards">
                                       <img src={`${img.src + i}.png`} alt="al-qur'an" />
                                       <footer>Al - Qur’an</footer>
                                    </div>
                               </Link>
                            </Col>
                        )
                    })
                }
            </Row>
            <br /><br />
            <Judul judul="Buku Umum" />
            <Row>
                    {
                        Images.map((img, i) => {
                            return (
                                <Col key={i} md={2}>
                                <div className="cards">
                                    <img src={`${img.src + i}.png`} alt="al-qur'an" />
                                    <footer>Al - Qur’an</footer>
                                </div>
                                </Col>
            
                            )
                        })
                    }
            </Row>
        </div>
    )
}

const Images = [
    {src:"asset/category/image"},
    {src:"asset/category/image"},
    {src:"asset/category/image"},
    {src:"asset/category/image"},
    {src:"asset/category/image"},
    {src:"asset/category/image"}
]
